import HomepageDispatcher from '../dispatcher/dispatcher'
import ActionTypes from '../constants/Action-Types'
import ajax from '../utils/ajax'
import { EMAIL_SIGN_UP_ENDPOINT } from '../constants/API-Endpoints'

export default {
  // Might want to find a more 'flux' solution to
  // `onError` handling
  submit (email, source, onError) {
    ajax({
      url: EMAIL_SIGN_UP_ENDPOINT,
      data: {
        INIT_SESSION: true,
        email,
        source
      }
    })
      .then(response => {
        HomepageDispatcher.dispatch({
          type: ActionTypes.EMAIL_SIGN_UP_SUBMIT,
          email
        })
      })
      .catch(error => {
        if (onError) onError(error)
      })
  }
}
